/*
 *  Product Recommendations
 *    Generates recommended products via Shopify's Product Recommendations API.
 *
 *  Version:
 *    1.0.0 - 2023/07/14
 */

import $ from 'jquery';
import { CarouselSection } from '../sections/carousel/carousel-section';
import * as ResponsiveSizes from '../settings/Responsive';
import { register } from './ShopifySection';
import { ajaxRequest } from '@process-creative/slate-theme-tools';

export const CONTAINER_SELECTOR = '[data-product-recommendations]';
export const PRODUCTS_SELECTOR = '[data-products-carousel]';
export const PRODUCTS_LOOP_SELECTOR = '[data-product-recommendations-loop-container]';

export const PRODUCT_ID = 'data-product-id';
export const CLASS_HIDDEN = 'is-hidden';

class ProductRecommendations extends CarouselSection {
  constructor(container) {
    super(container);
    this.container = container;

    this.productsLoopContainer = container.find(PRODUCTS_LOOP_SELECTOR);

    this.fetchRecommendations()
      .then(e => this.onFetch(e))
      .catch(e => this.onFetchError(e))
    ;
  }

  async fetchRecommendations() {
    let id = this.container.attr(PRODUCT_ID);

    //Fetch recommended products based on Shopify Recommended Product API.
    return await ajaxRequest('/recommendations/products','GET', {
      section_id: 'product-recommendations--inner',
      product_id: `${id}`,
      limit: 8
    });
  }

  onFetch(e) {
    //If Shopify couldn't fetch anything, return.
    if(!e && !e.length) return;

    this.productsLoopContainer.html(e);
    this.products = this.container.find(PRODUCTS_SELECTOR);
    if(!this.products.length) return;

    this.container.removeClass(CLASS_HIDDEN);
    this.initCarousel(this.products);
    // InitializeInactiveThumbnails();
  }

  onFetchError(e) {
    console.error(e);
  }

  optionOverrides() {
    return {
      infinite: this.products.data('infinite') === true ? true : false,
      autoplay: this.products.data('autoplay') == true,
      autoplaySpeed: (this.products.data('autoplay-speed') * 1000) || 5000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { 
            slidesToShow: 2,
            arrows: true
          }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: {
            slidesToShow: 3,
            arrows: true
          }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: {
            slidesToShow: 4,
            arrows: true
          }
        }
      ]
    }
  }
}

register(CONTAINER_SELECTOR, ProductRecommendations);
